import { Component } from '@angular/core';
import { AuthService } from '../../../services';

@Component({
  selector: 'home-button',
  templateUrl: './home-button.html'
})
export class HomeButtonComponent {
  constructor(private authService: AuthService) {}
}
